import { createAction } from 'redux-act';

export const addCommit = createAction();
export const addCommitError = createAction();
export const receivedResponseOnCommit = createAction();

export const getProjectByCommit = createAction();
export const loadProjectByCommitError = createAction();
export const receivedProjectByCommit = createAction();
export const clearCurrentProject = createAction();

export const receivedMyRepository = createAction();
export const getMyRepository = createAction();
export const getMyRepositoryError = createAction();

export const setActiveCommit = createAction();

export const getProjectByRepository = createAction();
export const getProjectByRepositoryError = createAction();
export const receivedProjectByRepository = createAction();

export const getRepository = createAction();
export const getRepositoryError = createAction();
export const receivedRepository = createAction();
